module.exports = __webpack_public_path__ + "img/passion-game.6a125c4d.png";